import React from "react";
import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BsCalendar3, BsClock } from "react-icons/bs";

function BlogCard({ blog }) {
  return (
    <motion.div whileHover={{ y: -4 }} transition={{ duration: 0.3 }}>
      <Card className="blog-card-view">
        <Link to={`/blog/${blog.slug}`} className="blog-link">
          <div className="blog-card-cover">
            <img
              src={blog.image}
              alt={blog.title}
              className="blog-card-image"
              loading="lazy"
            />
            <div
              className="blog-card-cover-overlay"
              style={{ background: blog.gradient }}
            />
            <span className="blog-card-tag">{blog.tags[0]}</span>
          </div>
          <Card.Body>
            <div className="blog-card-meta">
              <span>
                <BsCalendar3 /> {new Date(blog.date).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })}
              </span>
              <span>
                <BsClock /> {blog.readTime}
              </span>
            </div>
            <Card.Title>{blog.title}</Card.Title>
            <Card.Text>{blog.excerpt}</Card.Text>
            <span className="blog-read-more">Read article →</span>
          </Card.Body>
        </Link>
      </Card>
    </motion.div>
  );
}

export default BlogCard;
